import { Navigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const BusinessAdminRoute = ({ children }) => {
  const location = useLocation();
  const userAttributes = useSelector((state) => state.auth.userAttributes);

  // Check if user is Business Admin
  const isAdmin = userAttributes['custom:role'] === 'org_admin';
  const isBusinessUser = userAttributes['custom:signin_type'] === 'BUSINESS';

  if (!(isAdmin && isBusinessUser)) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

BusinessAdminRoute.propTypes = {
  children: PropTypes.node,
};
export default BusinessAdminRoute;
